/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { TimeOfDay } from '../models/TimeOfDay';

export class MonthlyConfig {
  /**
  * Days of the month to schedule backups. 
  */
  'daysOfMonth'?: Set<number>;
  'timeOfDay'?: TimeOfDay;
  /**
  * The window of time after the start time you want the backup to start, in minutes. Defaults to `240` (4 hours). 
  */
  'startWindowMinutes'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "daysOfMonth",
      "baseName": "daysOfMonth",
      "type": "Set<number>",
      "format": ""
    },
    {
      "name": "timeOfDay",
      "baseName": "timeOfDay",
      "type": "TimeOfDay",
      "format": ""
    },
    {
      "name": "startWindowMinutes",
      "baseName": "startWindowMinutes",
      "type": "number",
      "format": "long"
    }  ];

  static getAttributeTypeMap() {
    return MonthlyConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

